import { http } from "../../../shared/api/http"

/* ===== Push devices (per-user, for support/debug) ===== */

export type PushToken = {
  id: string
  token: string
  platform: string
  created_at: string
}

export const getUserPushTokensApi = (userId: string) =>
  http.get<{ items: PushToken[] }>(`/api/admin/users/${userId}/push-tokens`)

export const revokeUserPushTokensApi = (userId: string) =>
  http.delete<{ deleted_count: number }>(`/api/admin/users/${userId}/push-tokens`)

/* ===== Broadcast segments ===== */

export type NotificationFilters = {
  inactive_days?: number
  role?: "user" | "mentor" | "moderator" | "admin" | ""
  city?: string
  industry?: string
}

const cleanFilters = (filters: NotificationFilters) => {
  const out: Record<string, string | number> = {}
  if (filters.inactive_days !== undefined && filters.inactive_days !== null) out.inactive_days = filters.inactive_days
  if (filters.role) out.role = filters.role
  if (filters.city) out.city = filters.city
  if (filters.industry) out.industry = filters.industry
  return out
}

export const previewNotificationAudienceApi = (filters: NotificationFilters) =>
  http.post<{ count: number }>("/api/admin/notifications/preview", { filters: cleanFilters(filters) })

export type BroadcastPayload = {
  title: string
  body: string
  filters: NotificationFilters
  data?: Record<string, string>
}

export type NotificationCampaign = {
  id: string
  title: string
  body: string
  filters: NotificationFilters
  target_count: number
  sent_count: number
  failed_count: number
  created_by: string
  created_by_name: string
  created_at: string
}

export const sendBroadcastApi = (payload: BroadcastPayload) =>
  http.post<NotificationCampaign>("/api/admin/notifications/broadcast", {
    ...payload,
    filters: cleanFilters(payload.filters),
  })

/* ===== History ===== */

export type NotificationListResponse = {
  items: NotificationCampaign[]
  total?: number
}

export const listNotificationsApi = (limit: number, offset: number) =>
  http.get<NotificationListResponse>("/api/admin/notifications", { params: { limit, offset } })

export const getNotificationApi = (id: string) =>
  http.get<NotificationCampaign>(`/api/admin/notifications/${id}`)

export const deleteNotificationApi = (id: string) =>
  http.delete(`/api/admin/notifications/${id}`)
